import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import {route} from "../../../routes";
import {
  HeroBlock,
  GelContentContainer,
  GelContentRow,
  GelContentColumn, Role,
  ApiPager, Link, ButtonSecondary, Notices, withFlashState, Controls, withAuthentication, FormErrorSummary, withCourseGroupsApi
} from "cw-styleguide-react";
import withAssets from "../../../components/hoc/withAssets";

import CourseGroupsManageFilterForm from "../components/CourseGroupsManageFilterForm";
import {ROLE_PROVIDER, ROLE_STAFF} from "../../../constants";


class CourseGroupsManageView extends Component {


  /**
   * render
   * @returns {JSX.Element}
   */
    render() {
        return (
            <Fragment>
                <GelContentContainer>
                    <h1>{this.props.t('local:view.courseGroups.manage.title')}</h1>
                </GelContentContainer>
                <HeroBlock>
                  <Role roles={[ROLE_STAFF]}>
                    <p>{this.props.t('local:view.courseGroups.manage.introduction')}</p>
                  </Role>
                  <Role roles={[ROLE_PROVIDER]}>
                    <p>{this.props.t('local:view.courseGroups.manage.providerIntroduction')}</p>
                  </Role>
                </HeroBlock>

                <GelContentContainer>

                  <Notices messages={this.props.messages} />
                  <FormErrorSummary errors={this.props.formErrors}/>

                  {/* Display the page control buttons */}
                  <Role roles={[ROLE_STAFF]}>
                    <Controls>
                        <ButtonSecondary url={route('courseGroupsCreate')} title={this.props.t('local:view.courseGroups.manage.controls.create')}>{this.props.t('local:view.courseGroups.manage.controls.create')}</ButtonSecondary>
                    </Controls>
                  </Role>

                  <GelContentRow>
                        <GelContentColumn xs={12} sm={12} md={4} lg={4} mdPush={8} lgPush={8}>
                          <CourseGroupsManageFilterForm
                            values={this.props.filterValues}
                            handleChange={this.props.handleChange}
                            handleSubmit={this.props.handleSubmit}
                            handleReset={this.props.handleReset}
                            setCourseGroupProviderFilterToCurrentUser={this.props.setCourseGroupProviderFilterToCurrentUser}
                          />
                        </GelContentColumn>

                        <GelContentColumn  xs={12} sm={12} md={8} lg={8} mdPull={4} lgPull={4}>
                          <ApiPager
                            authorize={true}
                            api={this.props.courseGroupsApiGetEndpoint('course_groups_api_course_groups_q')}
                                    filters={{
                                      courseGroupName: this.props.filterValues.courseGroupName,
                                      courseGroupProvider: this.props.filterValues.courseGroupProviderId,
                                      courseGroupTypeId: this.props.filterValues.courseGroupTypeId,

                                    }}
                                    autoReload={false}
                                    sortOptions={[
                                      {
                                        value: 'rel',
                                        label: this.props.t('styleguide:forms.order.options.rel')
                                      },
                                      {
                                        value: 'asc',
                                        label: this.props.t('styleguide:forms.order.options.asc')
                                      },
                                      {
                                        value: 'desc',
                                        label: this.props.t('styleguide:forms.order.options.desc')
                                      }
                                    ]}
                                    initialOrder={this.props.filterValues['order']}
                                    initialPage={this.props.filterValues['page']}
                                    initialGroupSize={this.props.filterValues['groupSize']}
                                    reloadKey={this.props.reloadKey}
                                    handleStateChange={this.props.handleStateChange}
                                    onReloadResetPage={true}
                                    noResultsText={this.props.t('styleguide:messages.noResults')}
                                    hasResultsText={''}
                                    table={true}
                                    tableHeader={() => (
                                      <tr>
                                        <th>{this.props.t('local:view.courseGroups.manage.tableHeader.name')}</th>
                                        <th>{this.props.t('local:view.courseGroups.manage.tableHeader.type')}</th>
                                        <Role roles={[ROLE_STAFF]}>
                                        <th>{this.props.t('local:view.courseGroups.manage.tableHeader.provider')}</th>
                                        </Role>
                                      </tr>
                                    )}
                                    render={(courseGroup) => (<tr>
                                      <td><Link to={route('courseGroupsEdit' ,{"courseGroup" : courseGroup.courseGroupId})}>{courseGroup.courseGroupName}</Link></td>
                                      <td>{this.props.courses.assets.courseGroups.courseGroupTypeLookup[courseGroup.courseGroupTypeId]}</td>
                                      <Role roles={[ROLE_STAFF]}>
                                      <td>{courseGroup.cw_courseprovidername}</td>
                                      </Role>
                                    </tr>)}/>
                        </GelContentColumn>
                    </GelContentRow>
                </GelContentContainer>
            </Fragment>

        )
    }

}

export default withCourseGroupsApi(process.env)(withAuthentication(withFlashState(withAssets(withTranslation('local')(CourseGroupsManageView)))));
